var ezdia;
(function (ezdia) {
    var NAME = 'isDirty';
    var TYPE = 'ez.isDirty';
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var Default = {
        unload: true,
        buttons: false
    };
    var IsDirty = /** @class */ (function () {
        function IsDirty(elem, options) {
            this.elem = elem;
            this.init(options);
        }
        Object.defineProperty(IsDirty, "Default", {
            get: function () {
                return Default;
            },
            enumerable: false,
            configurable: true
        });
        IsDirty.prototype.field = function (element) {
            return hasChange.call(element);
        };
        IsDirty.prototype.isDirtyForm = function () {
            // eslint-disable-next-line no-underscore-dangle
            return this.dirty;
        };
        IsDirty.prototype.destroy = function () {
            $(window).off("beforeunload." + this.type + "." + this.id);
            this.$elem
                .removeData("ez." + this.type)
                .data('dirty', false)
                .off("ez." + this.type);
        };
        IsDirty.prototype.clearUnload = function () {
            $(window).off("beforeunload." + this.type + "." + this.id);
        };
        IsDirty.prototype.getOptions = function (options) {
            return __assign(__assign(__assign({}, Default), this.$elem.data()), options);
        };
        IsDirty.prototype.init = function (options) {
            this.type = TYPE;
            this.$elem = $(this.elem);
            this.id = this.$elem.attr('id');
            this.options = this.getOptions(options);
            this.dirtyInputs = [];
            this.dirty = false;
            this.render();
        };
        IsDirty.prototype.render = function () {
            bindEvents.call(this);
        };
        return IsDirty;
    }());
    // PRIVATE FUNCTIONS
    // =========================
    function bindEvents() {
        changeEvent.call(this);
        if (this.options.unload) {
            unload.call(this);
        }
    }
    function changeEvent() {
        var self = this;
        this.$elem
            .find(':input:not(:button):not([type=hidden])')
            .on("change." + this.type, function change() {
            isFormDirty.call(self, this);
        });
        var tarr = [];
        $.each(tinymce.editors, function each() {
            if (!this.inline && !this.settings.readonly && !tarr.includes(this.id)) {
                var elem_1 = $("#" + this.id);
                this.on('blur', function () {
                    isFormDirty.call(self, elem_1[0]);
                });
                tarr.push(this.id);
            }
        });
    }
    function hasChange() {
        var isChange = false;
        if ((this.type === 'text' ||
            this.type === 'textarea' ||
            this.type === 'hidden') &&
            this.defaultValue !== $(this).val()) {
            isChange = true;
        }
        else if ((this.type === 'radio' || this.type === 'checkbox') &&
            this.defaultChecked !== this.checked) {
            isChange = true;
        }
        else if (this.type === 'select-one' || this.type === 'select-multiple') {
            for (var x = 0; x < this.length; x++) {
                if (this.options[x].selected !== this.options[x].defaultSelected) {
                    isChange = true;
                }
            }
        }
        return isChange;
    }
    function isFormDirty(element) {
        var dirty = hasChange.call(element);
        var $element = $(element);
        if (dirty) {
            enable.call(this, $element);
        }
        else {
            disable.call(this, $element);
        }
    }
    function enable(element) {
        var isElemDirty = element.data('dirty');
        if (isElemDirty) {
            return;
        }
        var name = element[0].name;
        this.dirtyInputs.push(name);
        this.dirty = true;
        this.$elem.data('dirty', true);
    }
    function disable(element) {
        var name = element[0].name;
        var index = this.dirtyInputs.indexOf(name);
        if (index !== -1) {
            this.dirtyInputs.splice(index, 1);
        }
        if (this.dirtyInputs.length === 0) {
            this.dirty = false;
            element.data('dirty', false);
        }
    }
    function unload() {
        var self = this;
        // eslint-disable-next-line consistent-return
        $(window).on("beforeunload." + this.type + "." + this.id, function () {
            if (self.dirty &&
                ((self.id === 'updateFrm' &&
                    !self.$elem.find('#content').is(':empty')) ||
                    (self.id === 'bulkEditFrm' &&
                        !self.$elem.find('#quickactionfield').is(':empty')) ||
                    ($('#ez-content').length && !$('#ez-content').is(':empty')))) {
                return 'Are you sure to leave this page?';
            }
        });
    }
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */
    var publicMethods = {
        form: IsDirty.prototype.isDirtyForm,
        field: IsDirty.prototype.field,
        clearUnload: IsDirty.prototype.clearUnload,
        destroy: IsDirty.prototype.destroy
    };
    function jQueryInterface(option) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (typeof option === 'string' && option !== 'destroy') {
            return invokePublicMethod.call(this, option, args);
        }
        return createNewInstance.call(this, option);
    }
    function invokePublicMethod(methodName, args) {
        if (publicMethods[methodName]) {
            var inputObject = retrieveObjectFromElement(this);
            var result = publicMethods[methodName].apply(inputObject, args);
            if (typeof result === 'undefined') {
                return $(this);
            }
            return result;
        }
        throw new Error("method '" + methodName + "()' does not exist for input list.");
    }
    // eslint-disable-next-line consistent-return
    function retrieveObjectFromElement(element) {
        var inputObject = $(element).data(TYPE);
        if (inputObject && inputObject instanceof IsDirty) {
            return inputObject;
        }
    }
    function createNewInstance(option) {
        var $this = $(this);
        $this.each(function each() {
            var self = $(this);
            var data = self.data(TYPE);
            var options = typeof option === 'object' && option;
            if (typeof option === 'string') {
                data[option]();
            }
            else {
                if (data) {
                    data.destroy();
                }
                self.data(TYPE, (data = new IsDirty(this, options)));
                var attrId = self.attr('id');
                $.ezdia.widgetsInstance.add('isDirty', attrId, self, 'destroy');
            }
        });
        return $this;
    }
    $.fn[NAME] = jQueryInterface;
    $.fn[NAME].Constructor = IsDirty;
    $.fn[NAME].noConflict = function noConflict() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return jQueryInterface;
    };
})(ezdia || (ezdia = {}));
